import { MouseEvent } from 'react';
import { type useDispatch } from 'react-redux';
import { type AnyAction } from 'redux';

import { SelectedAlert } from '~/@types/redux';
import { CATEGORY_IDS } from '~/pages/Home/constants';
import { HomeActions, HomeThunks } from '~/pages/Home/redux';
import { IncomeRuleIds } from '~/pages/IncomeCalculator/enums';

export const signalRNavigationStatus = (
  response,
  waitForSignalR,
  selectedAlert,
) => {
  const selectedAlertTitle =
    selectedAlert === 'quickmatch'
      ? selectedAlert
      : selectedAlert?.displayTitle;
  if (response !== false && waitForSignalR) {
    return `Response from ${selectedAlertTitle} is good, Waiting for signalR to navigate to next alert.`;
  } else if (waitForSignalR) {
    return `Response from the ${selectedAlertTitle} is ${response}, Wont navigate to next alert`;
  } else {
    return `Value of waitForSignalR is ${waitForSignalR}, navigate to next alert without waiting for SignalR.`;
  }
};

export const handlePrimaryButtonClick = async (
  event: MouseEvent,
  onPrimaryButtonSubmit: (...args: any[]) => Promise<any>,
  dispatch: ReturnType<typeof useDispatch>,
  selectedAlert: SelectedAlert,
  waitForSignalR: boolean,
  selectedCategory: number,
  shouldAutoCheck: boolean,
  FEVerified: boolean,
  canWriteUnderwriterCheckbox: boolean,
  isUnderwriter: boolean,
  isSignalRConnected: boolean,
) => {
  event.preventDefault();
  dispatch(HomeActions.setShouldGetNextAlert(true));
  const response = await onPrimaryButtonSubmit(event);
  // SignalR CONSOLE MESSAGE
  // eslint-disable-next-line no-console
  console.log(signalRNavigationStatus(response, waitForSignalR, selectedAlert));

  if (response === false) {
    dispatch(HomeActions.setShouldGetNextAlert(false));
    return;
  }

  if (
    canWriteUnderwriterCheckbox &&
    selectedAlert &&
    selectedCategory !== CATEGORY_IDS.CLASSIFY &&
    selectedAlert.additionalReferences?.ExcludeUnderwriterVerification !==
      'True'
  ) {
    if (
      selectedAlert.ruleId !==
      IncomeRuleIds.NoDocumentationProvidedIncomeSummary
    ) {
      const nextVerifiedValue = shouldAutoCheck || FEVerified;
      if (nextVerifiedValue !== selectedAlert.isUnderwriterVerified) {
        dispatch(
          HomeThunks.saveUnderwriterVerification(
            nextVerifiedValue,
            selectedAlert,
          ) as unknown as AnyAction,
        );
      }
    }
  }

  // If !waitForSignalR, getNextAlert without waiting.
  if (!waitForSignalR) {
    dispatch(HomeActions.nextAlert(isUnderwriter) as unknown as AnyAction);
    dispatch(HomeActions.setShouldGetNextAlert(false));
  }
  if (waitForSignalR && !isSignalRConnected) {
    // wait for 5 seconds and then getNextAlert if SignalR is not connected
    setTimeout(() => {
      dispatch(HomeActions?.nextAlert?.(isUnderwriter) as unknown as AnyAction);
      dispatch(HomeActions?.setShouldGetNextAlert?.(false));
    }, 5000);
  }
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
};

export const handleSecondaryButtonClick = (event, onSecondaryButtonSubmit) => {
  event.preventDefault();
  onSecondaryButtonSubmit(event);
};
